import { render, staticRenderFns } from "./Stemdoer.vue?vue&type=template&id=00515d3a&scoped=true"
import script from "./stemdoer.ts?vue&type=script&lang=ts&external"
export * from "./stemdoer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00515d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00515d3a')) {
      api.createRecord('00515d3a', component.options)
    } else {
      api.reload('00515d3a', component.options)
    }
    module.hot.accept("./Stemdoer.vue?vue&type=template&id=00515d3a&scoped=true", function () {
      api.rerender('00515d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/stemdoer/Stemdoer.vue"
export default component.exports